"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenovationDetailsApiDomain = void 0;
const core_1 = require("@js-joda/core");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const utils_1 = require("../../../utils");
class RenovationDetailsApiDomain {
    constructor(props) {
        Object.assign(this, props);
    }
}
exports.RenovationDetailsApiDomain = RenovationDetailsApiDomain;
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], RenovationDetailsApiDomain.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "propertyAddress", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], RenovationDetailsApiDomain.prototype, "propertyFloor", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "propertyUnitNo", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "propertyPostalCode", void 0);
__decorate([
    (0, class_transformer_1.Transform)(utils_1.ClassTransformers.LocalDateClassTransformer),
    __metadata("design:type", core_1.LocalDate)
], RenovationDetailsApiDomain.prototype, "renovationStartDate", void 0);
__decorate([
    (0, class_transformer_1.Transform)(utils_1.ClassTransformers.LocalDateClassTransformer),
    __metadata("design:type", core_1.LocalDate)
], RenovationDetailsApiDomain.prototype, "renovationEndDate", void 0);
__decorate([
    (0, class_transformer_1.Transform)(utils_1.ClassTransformers.ArrayClassTransformer(utils_1.ClassTransformers.LocalDateClassTransformer)),
    __metadata("design:type", Array)
], RenovationDetailsApiDomain.prototype, "demolitionDates", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "renovationContractor", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "renovationContractorAddress", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "renovationContractorContactNo", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "renovationContractorInCharge", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "renovationContractorInChargeContactNo", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "renovationSiteSupervisor", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "renovationSiteSupervisorContactNo", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RenovationDetailsApiDomain.prototype, "renovationStatus", void 0);
//# sourceMappingURL=api-domain.js.map